import { IconButton, Text, Tooltip } from "@chakra-ui/react";
import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { RouteLink } from "shared/components/link/RouteLink";
import { AllocationIcon } from "shared/icons/AllocationIcon";
import { rootRoute } from "shared/navigation/Routes";

export interface FundFamilyUseAllocationTableAmountInfoIconProps {
  fundFamilyId: string;
  allocationRuleId: string;
  allocationRuleName: string;
  isDisabled?: boolean;
}

export const FundFamilyUseAllocationTableAmountInfoTooltip: React.FC<
  React.PropsWithChildren
> = ({ children }) => (
  <Trans
    ns="common"
    i18nKey="drawdown.amountInfo.tooltip"
    values={{ amount: children }}
  >
    Allocation % of Fund Family Total:
    <Text as="span" fontSize="13px" fontWeight="medium">
      10%
    </Text>
  </Trans>
);

export const FundFamilyUseAllocationTableAmountInfoIcon: React.FC<
  FundFamilyUseAllocationTableAmountInfoIconProps
> = ({ fundFamilyId, allocationRuleId, allocationRuleName, isDisabled }) => {
  const { t } = useTranslation(["common"]);
  return (
    <Tooltip
      isDisabled={isDisabled}
      label={t("common:drawdown.amountInfo.allocationRuleTooltip", {
        allocationRuleName,
      })}
      openDelay={0}
      closeDelay={0}
      bg="white"
    >
      <IconButton
        as={RouteLink}
        variant="ghost"
        p="0 !important"
        icon={<AllocationIcon w="16px !important" h="16px !important" />}
        display="flex"
        alignItems="center"
        justifyContent="center"
        w="24px"
        h="24px"
        tabIndex={0}
        target="_blank"
        isDisabled={isDisabled}
        aria-label={t("common:drawdown.amountInfo.allocationRuleTooltip", {
          allocationRuleName,
        })}
        to={
          rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .entities({})
            .allocations({})
            .edit({
              allocationRuleId,
            }).$
        }
      />
    </Tooltip>
  );
};
